import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { CartProvider } from './context/CartContext';
import { LanguageProvider } from './i18n';
import { AuthProvider } from './context/AuthContext';
import ptFavicon from './assets/images/PT_Logo_Transparent.png';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <LanguageProvider>
    <AuthProvider>
      <CartProvider>
        <App />
      </CartProvider>
    </AuthProvider>
  </LanguageProvider>
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Set favicon from bundled asset (PT_ICON.png in src/assets/images).
// This allows using the image from `src/` without copying into `public/`.

try {
  const setFavicon = (href) => {
    let link = document.querySelector("link[rel*='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = href;
  };

  setFavicon(ptFavicon);
} catch (e) {
  // Ignore if running in an environment where document isn't available.
  // Favicon will fall back to public/favicon.ico
}
